exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExerciseBottom-module__wrapper___2ftny{z-index:8;position:absolute;bottom:2em;display:grid;grid-auto-flow:column;gap:1.5em}", ""]);

// exports
exports.locals = {
	"wrapper": "ExerciseBottom-module__wrapper___2ftny"
};